import TaskWebsocket from '@/socket/TaskWebsocket';

/**
 * Mixin to bring in Sockets.
 * Only one component (ApplicationShell.ts) should mix this in.
 */
export default {
  data() {
    return {
      socket: null as TaskWebsocket | null
    };
  },
  computed: {
    taskUserIdInFocus(): number {
      return (this as any).$store.state.task.userIdInFocus;
    },
    individualIds(): number[] {
      return (this as any).$store.state.task.individualTaskIds;
    },
    watchDelegated(): boolean {
      return (this as any).$store.state.task.watchDelegated;
    }
  },
  watch: {
    taskUserIdInFocus() {
      (this as any).socket.fetchForUser(this.taskUserIdInFocus);
    },
    individualIds() {
      (this as any).socket.updateIndividualIds(this.individualIds);
    },
    watchDelegated(newVal: boolean) {
      (this as any).socket.watchDelegated(newVal);
    }
  },
  created() {
    (this as any).socket = new TaskWebsocket((this as any).$store);
  },
  beforeDestroy: function () {
    if ((this as any).socket) {
      (this as any).socket.close();
    }
  },
  methods: {}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/mixins/SocketMixin.ts